import { createSelector } from 'reselect'

const extensionPromotionSelector = ({ extensionPromotion }) => extensionPromotion

export const extensionPromoTypeShownSelector = createSelector(
  extensionPromotionSelector,
  ({ promoTypeShown }) => promoTypeShown
)
